<script lang="ts">
  import Header from "../Shared/Header.svelte";
  import Info from "./Info.svelte";
  import SignedIn from "./SignedIn.svelte";
  import SevenFiftyInfo from "./SevenFiftyInfo.svelte";
  import FlashWrapper from "@shared/svelte/Components/Flash/Wrapper.svelte";
  import { hasSevenFiftyPartnerSource } from "@onboarding2/services/retailer_user_signup";
  import type { UserSignUp, UserInfo } from "@shared/types/User";

  export let user: UserSignUp;
  export let userInfo: UserInfo;

  $: displayLogInOption = shouldDisplayLogInOption(userInfo);
  $: isSevenFiftyUser = hasSevenFiftyPartnerSource(user?.retailers);
  $: isSignedIn = !!userInfo?.signed_in;

  function shouldDisplayLogInOption(userInfo: UserInfo): boolean {
    return (
      userInfo &&
      !userInfo.signed_in &&
      !userInfo.email &&
      !userInfo.first_name &&
      !userInfo.last_name
    );
  }

</script>

<style>
  .fizz-layout-header-50-50 {
    min-height: 100vh;
  }

</style>

<div class="fizz-layout-header-50-50">
  <Header
    {displayLogInOption}
    {isSevenFiftyUser}
    hideTitleOnMobile={true}
    title={"Bars, restaurants and retailers"}
  />
  {#if isSevenFiftyUser}
    <SevenFiftyInfo />
  {:else}
    <Info />
  {/if}
  {#if isSignedIn}
    <SignedIn {userInfo} />
  {:else}
    <slot />
  {/if}
</div>

<FlashWrapper />
